import { render, staticRenderFns } from "./GeoReputationDetail.vue?vue&type=template&id=0a77c8e4&scoped=true"
import script from "./GeoReputationDetail.vue?vue&type=script&lang=js"
export * from "./GeoReputationDetail.vue?vue&type=script&lang=js"
import style0 from "./GeoReputationDetail.vue?vue&type=style&index=0&id=0a77c8e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a77c8e4",
  null
  
)

export default component.exports